import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-profile',
  templateUrl: './icon-profile.component.html',
  styleUrls: ['./icon-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconProfileComponent {}
